import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCU = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M0 4.348v41.304V4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50.002c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 0C16.821 0 9.56 3.928 5 10H45c-4.56-6.072-11.822-10-20-10ZM25 50c8.179 0 15.44-3.929 20.001-10H5C9.56 46.072 16.821 50 25 50ZM0 25c0 1.713.173 3.385.5 5h49c.327-1.615.5-3.287.5-5 0-1.712-.173-3.384-.5-5H.5a25.107 25.107 0 0 0-.5 5Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M7.322 7.323c-9.763 9.763-9.763 25.592 0 35.355L25 25 7.322 7.323Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m10.118 18.479 1.619 4.982h5.238l-4.238 3.08 1.619 4.981-4.238-3.079-4.238 3.08 1.619-4.983-4.238-3.08h5.238l1.619-4.981Z"
}));
FlagCU.displayName = 'FlagCU';
export default withFlagWrapper(FlagCU);
//# sourceMappingURL=index.js.map